import React from "react";

import "./App.css";
import * as Theme from "./Theme";

import OnlineHelpIcon from "../Img/DM/OnlineHelp2.png";
import SC_Icon from "../Img/SC/SC_Icon.png";
import DM_Icon from "../Img/DM/DM_Icon.png";

import { RESTService, SCService, DMService, LoginService } from "../API/server_calls";

/* Library */

import TAppBar from "../Library/App/TAppBar";
import TAppSideBar from "../Library/App/TAppSideBar";
import TAppContent from "../Library/App/TAppContent";
import TSplashScreen from "../Library/OtherComponents/TSplashScreen";
import TDrawerForm from "../Library/Drawers/TDrawerForm";
import TWifiAnimation from "../Library/OtherComponents/TWifiAnimation";
import TDialog from "../Library/Dialogs/TDialog";
import TErrorBoundary from "../Library/OtherComponents/TErrorBoundary";

/* GB */

import * as GBConst from "../Modules/GB/NonComponents/GBConst";
import { cloneObj, getModName } from "../Modules/GB/NonComponents/GBUtil";
import GBAppContentCustom from "../Modules/GB/App/GBAppContentCustom";
import GBRedirectForm from "../Modules/GB/Forms/GBRedirectForm";
import GBAppBarCustom from "../Modules/GB/App/GBAppBarCustom";

/* SC */

import SCAppSideBarCustom from "../Modules/SC/App/SCAppSideBarCustom";
import SCAppContentCustom from "../Modules/SC/App/SCAppContentCustom";
import * as SCConst from "../Modules/SC/NonComponents/SCConst";
import {
    getDefaultChartType,
    convertDelphiObjectListToJSON,
    getStartingCountryCode,
    getUserCountryObjList,
} from "../Modules/SC/NonComponents/SCDataUtil";
import { getStdResultCurrID, usingLocalHost } from "../Modules/SC/NonComponents/SCUtil";
import SCResultsDrawer from "../Modules/SC/Drawers/SCResultsDrawer";
import SCLocationsDrawer from "../Modules/SC/Drawers/SCLocationsDrawer";
import SCCharacteristicsDrawer from "../Modules/SC/Drawers/SCCharacteristicsDrawer";
import SCDataEntryDrawer from "../Modules/SC/Drawers/SCDataEntryDrawer";

/* DM */

import * as DMConst from "../Modules/DM/NonComponents/DMConst";
import { getVMMC_TargCov1DFltArray } from "../Modules/DM/NonComponents/DMDataUtil";
import DMAppSideBarCustom from "../Modules/DM/App/DMAppSideBarCustom";
import DMAppContentCustom from "../Modules/DM/App/DMAppContentCustom";
import DMNavComboBox from "../Modules/DM/OtherComponents/DMNavComboBox";

import * as GBTable from "../Modules/GB/NonComponents/GBTableUtil";

import eSwatiniFlagIcon from "../Img/eSwatiniFlag.png";

class App extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    constructor(props) {
        super(props);

        /*
           config = configOptObj from server

           configExtra = client-specific config states that need to be saved
               resultPlotType = choice of standard result vs custom result
               chartTypeClient = choice of line, bar, or table
               stdResID = current ID of standard result
               openProvCurrID = current ID of province opened in location drawer
               openSNU_CurrID = current ID of SNU opened in location drawer

           countryObjList = SC_TCountryObjList. Object list containing SC_TCountryDBData
               objects. Tells us everything we need to know about a country.
               Zero-based. REST data. Some useful fields are:

               country name
                   countryObjList[index].countryObj.name

               country code (master ID)
                   countryObjList[index].countryObj.mstID

               Note that not every SC_TCountryDBData is added to SC_TCountryObjList,
               so index is NOT equivalent to a country current ID.

           displayOL = SC_TDisplayOL. Object list containing SC_TDisplay objects.
               All information about standard results is contained in this.
               Zero-based. Service data. Some useful fields are:

               catID = categories/labels that standard result appear under
                   displayOL[index].catID

               mstID = standard result master ID
                   displayOL[index].mstID

               resID = standard result current ID
                   displayOL[index].resID

               name = standard result name
                   displayOL[index].name

               dispParams = array of display parameters telling us behavior for a result
                   displayOL[index].dispParams[index2]

               Note that not every SC_TDisplay is added to displayOL, so index is NOT
               equivalent to the standard result current ID.

           indInfo = SV_TIndInfoObj. Object containing all indicator information
               from server. Recall that the user selects indicators to contstruct
               custom graphs. One-based. REST data. Contains the  following 1D arrays by
               indicator current ID:

               indNames = indicator names
                   indInfo.indNames[indID]

               indCanGraph = tells us if the indicator can be graphed alongside
                   other indicators on a custom graph.
                   indInfo.indCanGraph[indID]

               indCats = categories/labels that indicators appear under
                   indInfo.indCats[indID]

               numItemsPerInd = number of items the indicator is divided into it; ex:
                  VMMCs performed may be divided into age groups
                  indInfo.numItemsPerInd[indID]

           siteCharByTimeInfo = SV_TSiteCharByTimeInfoObj. Object containing all site characteristic
               (by time) information from server.One-based. REST data. Contains the following 1D
               arrays by current ID:

                geoTypeNames,
                servDelivModeNames,
                PEPFAR_CatNames,
                VMMC_CatNames,
                DREAMS_CatNames,
                ownershipNames,
                USG_AgencyNames,
                impPartnerNames

                geoTypeMstIDs,
                servDelivModeMstIDs,
                PEPFAR_CatMstIDs,
                VMMC_CatMstIDs,
                DREAMS_CatMstIDs,
                ownershipMstIDs,
                USG_AgencyMstIDs,
                impPartnerMstIDs

           catInfo = SV_TCatInfoObj. Object containing all category information
               from server. Custom and standard results are organized by these
               categories. One-based. REST data. Contains the  following 1D arrays by
               category current ID:

               catNames = category names
                   catInfo.catNames[catID]

           mostRecentYearRanges = Array of SV_TYearRangeObj containing the most recent year(ish) range
             during which a site was open. Fields are:

               mostRecentYearRanges[siteID].startMonth
               mostRecentYearRanges[siteID].startYear
               mostRecentYearRanges[siteID].endMonth
               mostRecentYearRanges[siteID].endYear

           siteInfo = SV_SiteInfoObj. Contains the following 1D arrays by site
               current ID:

               provCurrIDs: province current IDs
                   siteInfo.provCurrIDs[siteID]

               SNU_CurrIDs: SNU current IDs
                   siteInfo.SNU_CurrIDs[siteID]

           mstIDsObj = SV_TMstIDsObj Object containing lists of master IDs. Contains the
             following 1D arrays by current ID.

             siteMstIDs:
                mstIDsObj.siteMstIDs[siteCurrID]

             displayParamMstIDs:
                mstIDsObj.displayParamMstIDs[index]

             stdResultMstIDs:
                mstIDsObj.stdResultMstIDs[index]

             indMstIDs:
                mstIDsObj.indMstIDs[index]

             catMstIDs:
                mstIDsObj.catMstIDs[index]
        */

        this.timer = undefined;
        this.pingSent = false;

        this.state = {
            /* SC data */

            SC: {
                allowedCountryMstIDs: [],
                catInfo: null,
                config: null,
                configExtra: {
                    resultPlotType: 0,
                    chartTypeClient: 0,
                    stdResID: 0,
                    openProvCurrID: 0,
                    openSNU_CurrID: 0,
                },
                countryObjList: null,
                displayOL: null,
                indInfo: null,
                mostRecentYearRangesArray: [],
                mstIDsObj: null,
                noPermittedCountries: false,
                packChart: null,
                packTable: null,
                selectedCountryCode: 0,
                siteCharByTimeInfo: null,
                siteInfo: null,
            },

            /* DM data */

            DM: {
                allowedCountryMstIDs: [],
                countryObjList: [
                    {
                        mstID: 0,
                        name: "",
                    },
                ], // country items - old; was a single object with 1d mstIDs and names arrays in it
                selectedFiscalYearStart: DMConst.octFYS,
                navOptionByte: DMConst.introOp,
                noPermittedCountries: false,
                province1DStrArray: [], // provinceItems
                //recalculateBool        : true,                             // recalculate
                results: {},
                selectedCountryMstID: 0, // countryID???
                selectedProvinceCurrID: 0, // provinceID ???
                selectedSNU_CurrID: 0, // snuID?
                selectedTargetYear: DMConst.defaultTargetYear,
                showGlobalOutputsBool: false, // crossCountry?
                showHelpDialog: false,
                SNU_1DStrArray: [], // snuItems
                VMMC_Coverage: [], // sheet
                VMMC_BaseCoverageYear: DMConst.firstYear, // baseCoverageYear
                targCoverageBySNU: { useSNU: false, coverages: null, names: [] },
            },

            /* Drawers */

            drawerContent: null,
            drawerOpen: false,
            drawerTitle: "",
            drawerXID: "",
            headerVisible: true,

            /* General */

            failedToLoad: false,
            humanName: "", //'guest',
            isGuest: true, //false,
            lastTimeServerAnswered: 0,
            loading: true,
            pageID: GBConst.GBStartScreenFormPg,
            pingSent: false,
            processingServerCall: false,
            numberPingsSuccess: 0,
            selectedModID: GBConst.GB_GB,
            sideBarOpen: false,
            signedIn: false,
            status: {
                TimeExpire: "",
                TimeIdle: "",
                TimeToLive: "",
                disconnectWarning: false,
                sessionsExists: false,
                status: 0,
            },

            covTable: {},
        };
    }

    //==================================================================================================================
    //
    //    Life Cycle Methods
    //
    //==================================================================================================================

    // componentDidMount () {
    //
    //     /* Similar to onFormCreate. */
    //
    //      this.fetchServerDataSC(() => {
    //
    //         this.setState({
    //             pageID  : GBConst.GBStartScreenFormPg,
    //             loading : false,
    //         });
    //
    //     });
    //
    //}

    componentDidMount() {
        /* Similar to onFormCreate. */

        this.setState(
            {
                loading: false,
            },
            () => {
                this.onPageChange(GBConst.GBStartScreenFormPg);
            }
        );
    }

    //==================================================================================================================
    //
    //     Utility Methods
    //
    //==================================================================================================================

    //==================================================================================================================
    //
    //   Event Handlers - VMMC/General
    //
    //==================================================================================================================

    onPageChange = (id, successFn) => {
        if (typeof id === "undefined" || id === "") {
            this.setState(
                {
                    pageID: this.state.pageID,
                },
                () => {
                    if (typeof successFn !== "undefined") {
                        successFn();
                    }
                }
            );

            return;
        }

        if (id === "back") {
            id = this.state.backPageID;
        }

        this.setState(
            {
                backPageID: this.state.pageID,
                pageID: id,
            },
            () => {
                if (typeof successFn !== "undefined") {
                    successFn();
                }
            }
        );
    };

    // Setting the state causes the app to render before the data is fetched
    onModuleChange = (modID) => {
        const sideBarOpen = modID !== GBConst.GB_GB;

        let pageID = GBConst.GBStartScreenFormPg;

        if (modID === GBConst.GB_SC) {
            pageID = SCConst.SCWelcomeFormPg;
        } else if (modID === GBConst.GB_DM) {
            pageID = DMConst.DMWelcomeFormPg;
        }

        this.setState(
            {
                selectedModID: modID,
                sideBarOpen: sideBarOpen,
            },
            () => {
                if (modID === GBConst.GB_SC) {
                    this.fetchServerDataSC(() => {
                        this.onPageChange(pageID);
                    });
                } else if (modID === GBConst.GB_DM) {
                    this.fetchServerDataDM(() => {
                        this.onPageChange(pageID);
                    });
                }
            }
        );
    };

    //==================================================================================================================
    //
    //          Event Handlers - SC
    //
    //==================================================================================================================

    onDrawerChangeSC = (id) => {
        /* State */
        const SC = this.state.SC;
        const catInfo = SC.catInfo;
        const config = SC.config;
        const configExtra = SC.configExtra;
        const countryObjList = SC.countryObjList;
        const displayOL = SC.displayOL;
        const indInfo = SC.indInfo;
        const mostRecentYearRangesArray = SC.mostRecentYearRangesArray;
        const mstIDsObj = SC.mstIDsObj;
        const selectedCountryCode = SC.selectedCountryCode;
        const siteCharByTimeInfo = SC.siteCharByTimeInfo;
        const siteInfo = SC.siteInfo;

        if (typeof id === "undefined" || id === "") {
            this.setState({
                drawerXID: "",
                drawerOpen: false,
            });

            return;
        }

        let drawerContent;
        let drawerTitle;
        let headerVisible = true;

        const sharedProps = {
            config: config,
            configExtra: configExtra,
            onConfigChange: this.onConfigChangeSC,
            countryObjList: countryObjList,
            displayOL: displayOL,
            mstIDsObj: mstIDsObj,
            onDrawerChange: this.onDrawerChangeSC,
        };

        switch (id) {
            case SCConst.resultsDrawer:
                drawerContent = (
                    <SCResultsDrawer
                        {...sharedProps}
                        indInfo={indInfo}
                        catInfo={catInfo}
                    />
                );
                drawerTitle = "Results";
                break;

            case SCConst.locationsDrawer:
                drawerContent = (
                    <SCLocationsDrawer
                        {...sharedProps}
                        selectedCountryCode={selectedCountryCode}
                        siteInfo={siteInfo}
                    />
                );
                drawerTitle = "Locations";
                break;

            case SCConst.characteristicsDrawer:
                drawerContent = (
                    <SCCharacteristicsDrawer
                        {...sharedProps}
                        displayOL={displayOL}
                    />
                );
                drawerTitle = "Characteristics";
                break;

            // case SCConst.timePeriodDrawer :
            //     content =
            //         <SCTimePeriodDrawer
            //             {...sharedProps}
            //             displayOL={displayOL}
            //         />;
            //     title = "Time period";
            //     break;

            case SCConst.editTemplateDrawer:
                /* In case the user choose to select sites and fill in an offline data
                   template, send in a clone of config with all provinces, SNUs, and sites
                   starting off checked. Also clone configExtra and set the open province and
                   SNU to 0.
                */
                let configClone = JSON.parse(JSON.stringify(config));
                let provincesIncluded = configClone[SCConst.provincesIncluded];
                let SNUsIncluded = configClone[SCConst.SNUsIncluded];
                let sitesIncluded = configClone[SCConst.sitesIncluded];

                for (let i = 0; i < sitesIncluded.length; i++) {
                    sitesIncluded[i] = true;
                }

                for (let i = 0; i < provincesIncluded.length; i++) {
                    provincesIncluded[i] = true;

                    for (let j = 0; j < SNUsIncluded.length; j++) {
                        SNUsIncluded[i][j] = true;
                    }
                }

                let configExtraClone = JSON.parse(JSON.stringify(configExtra));
                configExtraClone.openProvCurrID = 0;
                configExtraClone.openSNU_CurrID = 0;

                drawerContent = (
                    <SCDataEntryDrawer
                        countryObjList={countryObjList}
                        selectedCountryCode={selectedCountryCode}
                        catInfo={catInfo}
                        indInfo={indInfo}
                        mstIDsObj={mstIDsObj}
                        siteCharByTimeInfo={siteCharByTimeInfo}
                        mostRecentYearRangesArray={mostRecentYearRangesArray}
                        config={configClone}
                        configExtra={configExtraClone}
                        siteInfo={siteInfo}
                        onSave={this.onSaveEditTemplate}
                        onClose={this.onDrawerChangeSC}
                    />
                );
                drawerTitle = "Data entry";
                headerVisible = false;
                break;

            default:
                drawerContent = null;
                drawerTitle = "";
        }

        this.setState({
            drawerXID: id,
            drawerOpen: true,
            drawerContent: drawerContent,
            drawerTitle: drawerTitle,
            headerVisible: headerVisible,
        });
    };

    onConfigChangeSC = (config, configExtra, successFn) => {
        const SC = this.state.SC;

        /* Don't update the chart and table unless something actually changed in the
           configuration. Start by cloning the config options that are passed in and the
           ones held in state. */
        const configParamContents = JSON.parse(JSON.stringify(config));
        const configExtraParamContents = JSON.parse(JSON.stringify(configExtra));

        const configStateContents = JSON.parse(JSON.stringify(SC.config));
        const configExtraStateContents = JSON.parse(JSON.stringify(SC.configExtra));

        /* Ignore the chart type, since changing the chart type should have no effect on the
           packChart or packTable we retrieve from the server. */
        delete configExtraParamContents.chartTypeClient;
        delete configExtraStateContents.chartTypeClient;

        /* Convert to strings in order to compare. */
        const configParamContentsStr = JSON.stringify(configParamContents);
        const configExtraParamContentsStr = JSON.stringify(configExtraParamContents);

        const configStateContentsStr = JSON.stringify(configStateContents);
        const configExtraStateContentsStr = JSON.stringify(configExtraStateContents);

        let SC_Clone = JSON.parse(JSON.stringify(SC));
        SC_Clone.config = config;
        SC_Clone.configExtra = configExtra;

        this.setState(
            {
                SC: SC_Clone,
            },
            () => {
                if (
                    configParamContentsStr !== configStateContentsStr ||
                    configExtraParamContentsStr !== configExtraStateContentsStr
                ) {
                    this.updatePackChartAndTableSC(
                        () => {
                            if (typeof successFn !== "undefined") {
                                successFn();
                            }

                            this.onPageChange(SCConst.SCResultsFormPg);
                        },
                        () => {
                            this.handleServerError("An error occurred while getting data from the server.");
                        }
                    );
                } else {
                    /* We always want to fire the success function. */
                    if (typeof successFn !== "undefined") {
                        successFn();
                    }

                    this.onPageChange(SCConst.SCResultsFormPg);
                }
            }
        );
    };

    onCountryChangeSC = (selectedCountryCode) => {
        /* If the country changes, we basically have to restart everything. */
        const successFn = () => {
            this.setState(
                {
                    processingServerCall: false,
                },
                () => {
                    this.onPageChange(SCConst.SCResultsFormPg);
                }
            );
        };

        const errorFn = () => {
            this.setState({
                failedToLoad: true,
            });
        };

        let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
        SC_Clone.selectedCountryCode = selectedCountryCode;

        this.setState(
            {
                SC: SC_Clone,
                processingServerCall: true,
            },
            () => {
                this.loadDataSC(successFn, () => {
                    this.handleServerError("An error occurred while changing countries.", errorFn);
                });
            }
        );
    };

    //==================================================================================================================
    //
    //          Event Handlers - DM
    //
    //==================================================================================================================

    setCovTable = (covTable) => {
        this.setState({ covTable: covTable });
    };

    createTable = (coverages, names) => {
        const covTable = GBTable.resizePackTable(GBTable.getNewPackTable(), names.length + 1, 12);
        covTable.tableData.value[0][0] = "Target coverage by SNU";
        //Column headers
        covTable.tableData.value[0][1] = "EIMC";
        covTable.tableData.value[0][2] = "10-14";
        covTable.tableData.value[0][3] = "15-19";
        covTable.tableData.value[0][4] = "20-24";
        covTable.tableData.value[0][5] = "25-29";
        covTable.tableData.value[0][6] = "30-34";
        covTable.tableData.value[0][7] = "35-39";
        covTable.tableData.value[0][8] = "40-44";
        covTable.tableData.value[0][9] = "45-49";
        covTable.tableData.value[0][10] = "50-54";
        covTable.tableData.value[0][11] = "55-59";
        covTable.LockedCells = [[]];
        covTable.FontColors = [[]];

        for (let c = 1; c < 12; c++) {
            covTable.LockedCells[0].push(true);
            covTable.FontColors[0].push(0x000000);
        }

        //console.log(covTable.LockedCells);
        //covTable.LockedCells[1].push("true");
        // let lockedCells2DBoolArray = [];
        for (let r = 1; r <= names.length; r++) {
            covTable.tableData.value[r][0] = names[r - 1];
            covTable.LockedCells.push([]);
            covTable.FontColors.push([]);
            if (coverages[r - 1] !== "") {
                //console.log(coverages[r-1]);
                for (let c = 1; c < 12; c++) {
                    if (r === 1) {
                        covTable.LockedCells[r].push(true);
                        covTable.FontColors[r].push(0x666666);
                    } else {
                        covTable.LockedCells[r].push(false);
                        covTable.FontColors[r].push(0x000000);
                    }
                    covTable.tableData.value[r][c] = coverages[r - 1][c + 1];
                }
            }
            if (names[r - 1].charAt(0) === " ") {
                covTable.IndentRowText[r] = { xoffset: 10, Value: true };
            }
        }
        //console.log(covTable.LockedCells);
        this.setCovTable(covTable);
    };

    onCountryChangeDM = (selectedCountryMstID) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        // if (DM_Clone.selectedCountryMstID !== selectedCountryMstID) DM_Clone.targCoverageBySNU.useSNU = false;
        DM_Clone.selectedCountryMstID = selectedCountryMstID;
        let navOptionByte = DM_Clone.navOptionByte;

        if (
            navOptionByte === DMConst.countryDashOp &&
            selectedCountryMstID === DMConst.countryCodeSampleCountry //||
            //navOptionByte === DMConst.targCovBySNUOp
        ) {
            navOptionByte = DMConst.introOp;
        }

        this.setState(
            {
                processingServerCall: true,
            },
            () => {
                DMService.getTargCoverage(selectedCountryMstID, (response) => {
                    let coverages = JSON.parse(response).defaultCoverage;
                    let names = JSON.parse(response).coverageRowNames;

                    DM_Clone.targCoverageBySNU.coverages = coverages;
                    DM_Clone.targCoverageBySNU.names = names;

                    this.createTable(coverages, names);

                    this.setState(
                        {
                            DM: DM_Clone,
                        },
                        () => {
                            this.onNavOptionChangeDM(navOptionByte, () => {
                                this.handleGetProvinceListDM(() => {
                                    this.handleGetSNU_ListDM(() => {
                                        //API.getTargetYearList(() => {

                                        //this.handleUpdateInputsDM(() => {

                                        // this.handleCalculateDM(() => {

                                        this.handleGetBaselineVMMC_CoverageDM(() => {
                                            this.handleGetResultsDM(() => {
                                                this.setState({
                                                    processingServerCall: false,
                                                });
                                                //APP.renderCountryDashboard($("#country_select").val());
                                            });
                                        });

                                        //    });//handleCalculateDM

                                        // });//handleUpdateInputsDM

                                        //});
                                    });
                                });
                            });
                        }
                    );
                });
            }
        );
    };

    onProvinceChangeDM = (selectedProvinceCurrID) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.selectedProvinceCurrID = selectedProvinceCurrID;

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                this.handleGetSNU_ListDM(() => {
                    //API.getTargetYearList(() => {

                    //this.handleUpdateInputsDM(() => {

                    //this.handleCalculateDM(() => {

                    this.handleGetBaselineVMMC_CoverageDM(() => {
                        this.handleGetResultsDM(() => {
                            this.setState({
                                processingServerCall: false,
                            });
                        });
                    });

                    //});//handleCalculateDM

                    //});//handleUpdateInputsDM
                });
            }
        );
    };

    onSNU_ChangeDM = (selectedSNU_CurrID) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.selectedSNU_CurrID = selectedSNU_CurrID;

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                //this.handleUpdateInputsDM(() => {

                //this.handleCalculateDM(() => {

                this.handleGetBaselineVMMC_CoverageDM(() => {
                    this.handleGetResultsDM(() => {
                        this.setState({
                            processingServerCall: false,
                        });
                    });
                });

                //});//handleCalculateDM

                //});//handleUpdateInputsDM
            }
        );
    };

    onTargetYearChangeDM = (selectedTargetYear) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.selectedTargetYear = selectedTargetYear;

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                //this.handleUpdateInputsDM(() => {

                //this.handleCalculateDM(() => {

                this.handleGetBaselineVMMC_CoverageDM(() => {
                    this.handleGetResultsDM(() => {
                        this.setState({
                            processingServerCall: false,
                        });
                    });
                });

                //});//handleCalculateDM

                //});//handleUpdateInputsDM
            }
        );
    };

    onFiscalYearStartChangeDM = (selectedFiscalYearStart) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.selectedFiscalYearStart = selectedFiscalYearStart;

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                //this.handleUpdateInputsDM(() => {

                //this.handleCalculateDM(() => {

                this.handleGetBaselineVMMC_CoverageDM(() => {
                    this.handleGetResultsDM(() => {
                        this.setState({
                            processingServerCall: false,
                        });
                    });
                });

                //});//handleCalculateDM

                //});//handleUpdateInputsDM
            }
        );
    };

    onHandleTargBySNUFlagChange = (useSNU) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.targCoverageBySNU.useSNU = useSNU;

        if (DM_Clone.targCoverageBySNU.useSNU) {
            DM_Clone.navOptionByte = DMConst.targCovBySNUOp;
        } else {
            DM_Clone.targCoverageBySNU.coverages = null;
            DM_Clone.targCoverageBySNU.names = [];
            DM_Clone.navOptionByte = DMConst.introOp;
        }

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                if (!this.state.DM.targCoverageBySNU.useSNU || !(this.state.DM.targCoverageBySNU.coverages === null)) {
                    this.handleGetResultsDM(() => {});
                }
                this.setState({
                    processingServerCall: false,
                });
            }
        );
    };

    onHandleTargBySNUCovChange = (coverages, names) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.targCoverageBySNU.coverages = coverages;
        DM_Clone.targCoverageBySNU.names = names;
        this.setState(
            {
                DM: DM_Clone,
            },
            () => {
                this.handleGetResultsDM(() => {});
            }
        );
    };

    onShowGlobalOutputsChangeDM = (showGlobalOutputsBool) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.showGlobalOutputsBool = showGlobalOutputsBool;

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                //this.handleUpdateInputsDM(() => {

                //this.handleCalculateDM(() => {

                this.handleGetBaselineVMMC_CoverageDM(() => {
                    this.handleGetResultsDM(() => {
                        this.onNavOptionChangeDM(DMConst.introOp, () => {
                            this.setState({
                                processingServerCall: false,
                            });
                        });
                    });
                });

                //});//handleCalculateDM

                //});//handleUpdateInputsDM
            }
        );
    };

    //mark start
    onVMMC_CoverageChange = (VMMC_TargCov1DFltArray) => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        let VMMC_Coverage = DM_Clone.VMMC_Coverage;

        for (let i = 1; i <= VMMC_TargCov1DFltArray.length; i++) {
            VMMC_Coverage[i - 1][DMConst.targetCoverage - 1] = VMMC_TargCov1DFltArray[i - 1];
        }

        this.setState(
            {
                DM: DM_Clone,
                processingServerCall: true,
            },
            () => {
                //this.handleUpdateInputsDM(() => {

                //this.handleCalculateDM(() => {

                //this.handleGetBaselineVMMC_CoverageDM(() => {

                this.handleGetResultsDM(() => {
                    this.setState({
                        processingServerCall: false,
                    });
                });

                //});

                //});//handleCalculateDM

                //});//handleUpdateInputsDM
            }
        );
    };

    /*onRecalculateChangeDM = (recalculateBool) => {

        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.recalculateBool = recalculateBool;

        this.setState({

            DM : DM_Clone,

        }, () => {

            this.handleUpdateInputsDM(() => {

                this.handleCalculateDM(() => {

                    this.handleGetBaselineVMMC_CoverageDM(() => {

                        this.handleGetResultsDM(() => {


                        });

                    });

                });

            });

        });

    };*/

    onNavOptionChangeDM = (navOptionByte, successFn) => {
        let pageID = this.state.pageID;

        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.navOptionByte = navOptionByte;

        switch (navOptionByte) {
            case DMConst.introOp:
                pageID = DMConst.DMWelcomeFormPg;
                break;

            case DMConst.countryDashOp:
                pageID = DMConst.DMDashboardFormPg;
                break;
            case DMConst.targCovBySNUOp:
                pageID = DMConst.DMCoverageFormPg;
                break;

            case DMConst.targPriorAchOp:
                pageID = DMConst.DMTargVsPriorAchievFormPg;
                break;

            case DMConst.progCovByAgeGroupOp:
                pageID = DMConst.DMProgCovByAgeGroupFormPg;
                break;

            case DMConst.progCovBySNUOp:
                pageID = DMConst.DMProgCovBySNUFormPg;
                break;

            case DMConst.covTableByAgeSNUOp:
                pageID = DMConst.DMCovByAgeSNUFormPg;
                break;

            case DMConst.impactHIVInfectAvertOp:
                pageID = DMConst.DMImpactHIVInfAvertedFormPg;
                break;

            case DMConst.impactVMMCsReqOp:
                pageID = DMConst.DMVMMCsReqPerHIVInfAvertedFormPg;
                break;

            case DMConst.progCovByCountryOp:
                pageID = DMConst.DMProgCovByCountryFormPg;
                break;

            case DMConst.covTableByAgeCountryOp:
                pageID = DMConst.DMCovTableByAgeCountryFormPg;
                break;

            case DMConst.agePriorAnal1Op:
                pageID = DMConst.DMAPA1FormPg;
                break;

            case DMConst.agePriorAnal2Op:
                pageID = DMConst.DMAPA2FormPg;
                break;

            case DMConst.agePriorAnal3Op:
                pageID = DMConst.DMAPA3IncrCovFormPg;
                break;

            case DMConst.agePriorAnalOp:
                pageID = DMConst.DMAPA123FormPg;
                break;

            case DMConst.agePriorAnal3UptakeCountryOp:
                pageID = DMConst.DMAPA3UptakeRateByCountryFormPg;
                break;

            case DMConst.circumPopsByAgeGroupOp:
                pageID = DMConst.DMMalePopByAgeGroupFormPg;
                break;

            default:
                break;
        }

        this.setState(
            {
                DM: DM_Clone,
            },
            () => {
                this.onPageChange(pageID, () => {
                    if (typeof successFn !== "undefined") {
                        successFn();
                    }
                });
            }
        );
    };

    onHelpClickDM = () => {
        let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
        DM_Clone.showHelpDialog = !DM_Clone.showHelpDialog;

        this.setState({
            DM: DM_Clone,
        });
    };

    //==================================================================================================================
    //
    //            API Related (Server Communication) - VMMC, General
    //
    //=================================================================================================================

    handleServerError = (errorStr, errorFn) => {
        alert(errorStr);

        this.setState({
            processingServerCall: false,
        });

        if (typeof errorFn !== "undefined") {
            errorFn();
        }
    };

    //==================================================================================================================
    //
    //            API Related (Server Communication) - VMMC, Login
    //
    //==================================================================================================================

    createTimer = () => {
        let timeInMilliseconds = 5000;

        if (usingLocalHost) {
            /* pinging during debugging is annoying */
            timeInMilliseconds = 5000000;
        }

        this.timer = setInterval(() => {
            this.handlePing();
        }, timeInMilliseconds);
    };

    destroyTimer = () => {
        clearInterval(this.timer);
    };

    handleDisconnectWarningDialogClose = (action) => {
        if (action === "mrYes") {
            this.handleSignedIn(() => {});
        } else if (action === "mrNo") {
            this.handleLogout();
        }
    };

    handlePing = () => {
        /* State */
        let state = this.state;
        const signedIn = state.signedIn;
        let lastTimeServerAnswered = state.lastTimeServerAnswered;

        const errorFn = () => {
            if (lastTimeServerAnswered > 3) {
                alert(
                    "Server may currently not be available.  Please refresh your browser to see if the issue is resolved."
                );
                this.pingSent = false;
                this.destroyTimer();
                this.setState({
                    processingServerCall: false,
                    status: {
                        sessionExists: false,
                    },
                });
            }
        };

        this.setState({
            lastTimeServerAnswered: lastTimeServerAnswered + 1,
        });

        if (this.state.lastTimeServerAnswered > 3) {
            errorFn();
        }

        if (!this.pingSent) {
            this.pingSent = true;

            LoginService.ping((response) => {
                this.numberPingsSuccess++;
                this.pingSent = false;

                this.setState({
                    lastTimeServerAnswered: 0,
                    status: response,
                });

                if (!response.sessionExists && signedIn) {
                    this.destroyTimer();
                }
            }, errorFn);
        }
    };

    handleSignedIn = (successFn, errorFn) => {
        LoginService.signedIn(
            (response) => {
                if (response) {
                    LoginService.getHumanName((response) => {
                        if (response === "Guest") {
                            this.setState(
                                {
                                    signedIn: true,
                                    isGuest: true,
                                    status: {},
                                },
                                successFn
                            );
                        } else {
                            this.setState(
                                {
                                    signedIn: true,
                                    isGuest: false,
                                    status: {},
                                },
                                successFn
                            );
                        }
                    });
                } else {
                    LoginService.loginAsGuest(
                        window.VIPT_Version,
                        (response2) => {
                            this.setState(
                                {
                                    signedIn: true,
                                    isGuest: true,
                                    status: {},
                                },
                                successFn
                            );
                        },
                        () => {
                            this.handleServerError("An error cocurred while logging in as a guest.", errorFn);
                        }
                    );
                }
            },
            () => {
                this.handleServerError("An error occurred while signing in.", errorFn);
            }
        );
    };

    handleHumanName = (successFn, errorFn) => {
        LoginService.getHumanName(
            (response) => {
                this.setState(
                    {
                        humanName: response,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error occurred while retrieving account name.", errorFn);
            }
        );
    };

    //==================================================================================================================
    //
    //            API Related (Server Communication) - SC, General
    //
    //==================================================================================================================

    // fetchServerDataSC = (successFn) => {
    //
    //     /* If getCountryList is successful, set the countryObjList to the countryObjList it returns.
    //        Then try to log in. If login is sucessful, call createProject to create the SC session
    //        and load country defaults. If createProject is successful, call getConfigOptObj to get
    //        the configuration options object. If getConfigOptObj is successful, call getConfigOptObjSuccess,
    //        defined above.
    //
    //        function syntax:
    //
    //        functionName(paramsToServer..., (valuesBackFromServer...) => {
    //          codeToExecuteUponSuccess
    //        }, codeToExecuteUponFailure); */
    //
    //     const errorFn = () => {
    //
    //         this.setState({
    //
    //             failedToLoad : true,
    //
    //         });
    //
    //     };
    //
    //     this.setState({
    //
    //         processingServerCall : true,
    //
    //     }, () => {
    //
    //         this.handleSignedIn(() => {
    //
    //             this.handleHumanName(() => {
    //
    //                 SCService.getAllowedCountryMstIDs((allowedCountryMstIDs) => {
    //
    //                     let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
    //                     SC_Clone.allowedCountryMstIDs = allowedCountryMstIDs;
    //
    //                     this.setState({
    //
    //                         SC : SC_Clone,
    //
    //                     }, () => {
    //
    //                         this.handleCountryList(() => {
    //
    //                             //this.handleMstIDs(() => {
    //
    //                             this.reloadSCData(successFn, () => {
    //
    //                                 this.handleServerError("An error occurred while fetching data from the server.", errorFn)
    //
    //                             });
    //
    //                             //}, errorFn);
    //
    //                         }, errorFn);
    //
    //                     });
    //
    //                 }, errorFn);
    //
    //             }, errorFn);
    //
    //         }, errorFn);
    //
    //     });
    //
    // };

    fetchServerDataSC = (successFn) => {
        /* If getCountryList is successful, set the countryObjList to the countryObjList it returns.
           Then try to log in. If login is sucessful, call createProject to create the SC session
           and load country defaults. If createProject is successful, call getConfigOptObj to get
           the configuration options object. If getConfigOptObj is successful, call getConfigOptObjSuccess,
           defined above.

           function syntax:

           functionName(paramsToServer..., (valuesBackFromServer...) => {
             codeToExecuteUponSuccess
           }, codeToExecuteUponFailure); */

        const errorFn = () => {
            this.setState({
                failedToLoad: true,
            });
        };

        this.setState(
            {
                processingServerCall: true,
            },
            () => {
                this.handleSignedIn(() => {
                    this.handleHumanName(() => {
                        SCService.getAllowedCountryMstIDs((allowedCountryMstIDs) => {
                            let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                            SC_Clone.allowedCountryMstIDs = allowedCountryMstIDs;

                            this.setState(
                                {
                                    SC: SC_Clone,
                                },
                                () => {
                                    this.handleCountryListSC(() => {
                                        const SC_Clone = JSON.parse(JSON.stringify(this.state.SC));

                                        if (!SC_Clone.noPermittedCountries) {
                                            this.loadDataSC(successFn, () => {
                                                this.handleServerError(
                                                    "An error occurred while fetching data from the server.",
                                                    errorFn
                                                );
                                            });
                                        } else {
                                            this.setState({
                                                processingServerCall: false,
                                            });

                                            this.createTimer();

                                            if (successFn !== "undefined") {
                                                successFn();
                                            }
                                        }

                                        //}, errorFn);
                                    }, errorFn);
                                }
                            );
                        }, errorFn);
                    }, errorFn);
                }, errorFn);
            }
        );
    };

    loadDataSC = (successFn, errorFn) => {
        this.handleCreateProjectSC(() => {
            this.handleIndInfoObjSC(() => {
                this.handleSiteCharByTimeInfoObjSC(() => {
                    /* Not country-dependent. */
                    this.handleCatInfoObjSC(() => {
                        /* Not country-dependent */
                        this.handleMstIDsSC(() => {
                            this.handleMostRecentYearRangesSC(() => {
                                this.handleSiteInfoObjSC(() => {
                                    this.handleConfigOptObjSC(() => {
                                        this.handleDisplayObjListSC(() => {
                                            this.handleUpdatePackChartAndTableSC(() => {
                                                this.setState({
                                                    processingServerCall: false,
                                                });

                                                this.createTimer();

                                                if (successFn !== "undefined") {
                                                    successFn();
                                                }
                                            }, errorFn);
                                        }, errorFn);
                                    }, errorFn);
                                }, errorFn);
                            }, errorFn);
                        }, errorFn);
                    }, errorFn);
                }, errorFn);
            }, errorFn);
        }, errorFn);
    };

    setInitialDefaultCountryCodeSC = (successFn) => {
        /* State */
        const state = this.state;
        const SC = state.SC;
        const allowedCountryMstIDs = SC.allowedCountryMstIDs;
        const countryObjList = SC.countryObjList;
        const isGuest = state.isGuest;

        let SC_Clone = JSON.parse(JSON.stringify(SC));
        const userCountryObjList = getUserCountryObjList(isGuest, countryObjList, allowedCountryMstIDs);

        if (typeof userCountryObjList !== "undefined" && userCountryObjList.length > 0) {
            SC_Clone.selectedCountryCode = getStartingCountryCode(userCountryObjList);
            SC_Clone.noPermittedCountries = false;
        } else {
            SC_Clone.noPermittedCountries = true;
        }

        this.setState(
            {
                SC: SC_Clone,
            },
            successFn
        );
    };

    /* Gets the packChart and packTable from the server based on the state's config and configExtra and
    updates them on the client. */
    updatePackChartAndTableSC = (successFn, errorFn) => {
        /* State */
        const SC = this.state.SC;
        const config = SC.config;
        const configExtra = SC.configExtra;
        const mstIDsObj = SC.mstIDsObj;

        let resID;

        if (configExtra.resultPlotType === SCConst.flexiblePlotType) {
            resID = getStdResultCurrID(mstIDsObj, SCConst.customResMstID);
        } else {
            resID = configExtra.stdResID;
        }

        this.setState(
            {
                processingServerCall: true,
            },
            () => {
                this.handleResultTableSC(resID, config, configExtra, () => {
                    this.handleResultChartSC(resID, config, () => {
                        this.setState({
                            processingServerCall: false,
                        });

                        const SC = this.state.SC;
                        const packChart = SC.packChart;
                        const packTable = SC.packTable;

                        if (packTable !== null && packChart !== null) {
                            if (successFn !== undefined) {
                                successFn();
                            }
                        } else {
                            if (errorFn !== undefined) {
                                errorFn();
                            }
                        }
                    });
                });
            }
        );
    };

    //==================================================================================================================
    //
    //            API Related (Server Communication) - SC, Rest
    //
    //==================================================================================================================

    handleCountryListSC = (successFn, errorFn) => {
        RESTService.getCountryList(
            window.VIPT_Version,
            (countryObjList) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.countryObjList = convertDelphiObjectListToJSON(countryObjList);

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    () => {
                        this.setInitialDefaultCountryCodeSC(successFn);
                    }
                );
            },
            () => {
                this.handleServerError("An error occurred while retrieving the countries from the server.", errorFn);
            }
        );
    };

    handleCatInfoObjSC = (successFn, errorFn) => {
        RESTService.getCatInfoObj(
            (catInfo) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.catInfo = catInfo;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error occurred while retrieving the category information from the server.",
                    errorFn
                );
            }
        );
    };

    //==================================================================================================================
    //
    //            API Related (Server Communication) - SC, Non-Rest
    //
    //==================================================================================================================

    handleMstIDsSC = (successFn, errorFn) => {
        SCService.getMstIDs(
            (mstIDsObj) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.mstIDsObj = mstIDsObj;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error occurred while retrieving keys from the server.", errorFn);
            }
        );
    };

    handleIndInfoObjSC = (successFn, errorFn) => {
        SCService.getIndInfoObj(
            (indInfo) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.indInfo = indInfo;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error occurred while retrieving the indicator information from the server.",
                    errorFn
                );
            }
        );
    };

    handleSiteCharByTimeInfoObjSC = (successFn, errorFn) => {
        SCService.getSiteCharByTimeInfoObj(
            (siteCharByTimeInfo) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.siteCharByTimeInfo = siteCharByTimeInfo;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error occurred while retrieving the site characteristic information from the server.",
                    errorFn
                );
            }
        );
    };

    handleMostRecentYearRangesSC = (successFn, errorFn) => {
        SCService.getMostRecentYearRanges(
            (mostRecentYearRangesArray) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.mostRecentYearRangesArray = mostRecentYearRangesArray;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error occurred while retrieving site availability data from the server.",
                    errorFn
                );
            }
        );
    };

    handleCreateProjectSC = (successFn, errorFn) => {
        /* State */
        const SC = this.state.SC;
        const selectedCountryCode = SC.selectedCountryCode;

        SCService.createProject(
            selectedCountryCode,
            () => {
                successFn();
            },
            () => {
                this.handleServerError("An error has occurred while creating the project.", errorFn);
            }
        );
    };

    handleSiteInfoObjSC = (successFn, errorFn) => {
        SCService.getSiteInfoObj(
            (siteInfo) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.siteInfo = siteInfo;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error occurred while retrieving site information from the server.", errorFn);
            }
        );
    };

    handleConfigOptObjSC = (successFn, errorFn) => {
        SCService.getConfigOptObj(
            (config) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.config = config;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error has occurred while retrieving the configuration options from the server.",
                    errorFn
                );
            }
        );
    };

    handleDisplayObjListSC = (successFn, errorFn) => {
        const SC = this.state.SC;
        const mstIDsObj = SC.mstIDsObj;
        const config = SC.config;
        const configExtra = SC.configExtra;

        SCService.getDisplayOL(
            (displayOL) => {
                let SC_Clone = JSON.parse(JSON.stringify(SC));

                let configCloned = JSON.parse(JSON.stringify(config));

                const stdResID = getStdResultCurrID(mstIDsObj, SCConst.addStaffNeededOptOpResMstID);
                /* Must be set to aggregate view here if the result we default to cannot be shown as
               a trend graph (which includes any graphs that show multiple indicators). */
                const graphViewType = SCConst.aggregateView;

                configCloned.graphViewType = graphViewType;
                const resultPlotType = SCConst.standardPlotType;
                const chartTypeClient = getDefaultChartType(stdResID, configCloned, configExtra, displayOL, mstIDsObj);
                const openProvCurrID = 0;
                const openSNU_CurrID = 0;
                //mark let flexiblePlotIndIDs = [0, 13]; // Number of surgical beds

                const configExtraNew = {
                    resultPlotType: resultPlotType,
                    chartTypeClient: chartTypeClient,
                    stdResID: stdResID,
                    openProvCurrID: openProvCurrID,
                    openSNU_CurrID: openSNU_CurrID,
                    //markflexiblePlotIndIDs : flexiblePlotIndIDs,
                };

                SC_Clone.displayOL = displayOL;
                SC_Clone.config = configCloned;
                SC_Clone.configExtra = configExtraNew;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error has occurred while retrieving displays from the server.", errorFn);
            }
        );
    };

    handleResultTableSC = (stdResID, config, configExtra, successFn, errorFn) => {
        /* State */
        const SC = this.state.SC;
        const mstIDsObj = SC.mstIDsObj;

        /* If we are showing the performance against target standard result as a table and either
           VMMC target or performance against target is 0, then set the value to N/A. */
        const modifyPackTable = (packTable, successFn) => {
            const chartTypeClient = configExtra.chartTypeClient;
            const resultPlotType = configExtra.resultPlotType;
            const timeInterval = config[SCConst.timeInterval];

            const performAgainstTargetResID = getStdResultCurrID(mstIDsObj, SCConst.performAgainstTargetResMstID);
            let startRow = 1;
            let cellValue = "";

            if (chartTypeClient === SCConst.table) {
                if (resultPlotType === SCConst.flexiblePlotType) {
                    if (stdResID === performAgainstTargetResID) {
                        if (timeInterval[SCConst.aggregateView] === SCConst.year) {
                            startRow = 1;
                        } else {
                            startRow = 2;
                        }

                        for (let row = startRow; row < packTable.GBRowCount; row++) {
                            for (let col = 0; col < packTable.GBColCount; col++) {
                                cellValue = packTable.tableData.value[row][col];

                                if (cellValue === 0) {
                                    if (
                                        (startRow === 2 && (row % 3 === 0 || row % 4 === 0)) ||
                                        (startRow === 1 && (row % 2 === 0 || row % 3 === 0))
                                    ) {
                                        packTable.tableData.value[row][col] = "N/A";
                                    }
                                }
                            }
                        }
                    }
                }
            }

            successFn(packTable);
        };

        SCService.getResultTable(
            stdResID,
            config,
            (packTable) => {
                let modifiedPackTableSuccessFn = (modifiedPackTable) => {
                    let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                    SC_Clone.packTable = modifiedPackTable;

                    this.setState(
                        {
                            SC: SC_Clone,
                        },
                        successFn
                    );
                };

                modifyPackTable(packTable, () => {
                    modifiedPackTableSuccessFn(packTable);
                });
            },
            () => {
                this.handleServerError("An error has occurred while retrieving result table from the server.", errorFn);
            }
        );
    };

    handleResultChartSC = (resID, config, successFn, errorFn) => {
        SCService.getResultChart(
            resID,
            config,
            (packChart) => {
                let SC_Clone = JSON.parse(JSON.stringify(this.state.SC));
                SC_Clone.packChart = packChart;

                this.setState(
                    {
                        SC: SC_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error has occurred while retrieving result chart from the server.", errorFn);
            }
        );
    };

    handleUpdatePackChartAndTableSC = (successFn, errorFn) => {
        this.updatePackChartAndTableSC(
            () => {
                this.setState(
                    {
                        loading: false,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error has occurred while retrieving the result from the server.", errorFn);
            }
        );
    };

    //==================================================================================================================
    //
    //            API Related (Server Communication) - DM
    //
    //==================================================================================================================

    fetchServerDataDM = (successFn) => {
        const errorFn = () => {
            this.setState({
                failedToLoad: true,
            });
        };

        this.setState(
            {
                processingServerCall: true,
            },
            () => {
                this.handleSignedIn(() => {
                    this.handleHumanName(() => {
                        // like SCService.getAllowedCountryMstIDs; handled inside loadDataDM for DM to
                        // mimic original
                        // DMService.getCountryList((allowedCountryMstIDs) => {
                        //
                        //     let DM_Clone = JSON.parse(JSON.stringify(this.state.DM));
                        //     DM_Clone.allowedCountryMstIDs = allowedCountryMstIDs;
                        //
                        //     this.setState({
                        //
                        //         DM : DM_Clone,
                        //
                        //     }, () => {

                        // this.handleCountryList(() => {

                        this.loadDataDM(successFn, () => {
                            this.handleServerError(
                                "An error occurred while fetching DMPPT2 data from the server.",
                                errorFn
                            );
                        });

                        // }, errorFn);

                        //     });
                        //
                        // }, errorFn);
                    }, errorFn);
                }, errorFn);
            }
        );
    };

    loadDataDM = (successFn, errorFn) => {
        this.handleGetCountryListDM(() => {
            this.handleGetProvinceListDM(() => {
                /* If the server successfully returned with an empty country list, then don't bother making any
                   more calls to the server. Assume that the user doesn't have country permissions with the
                   available data and point them to the previous iteration of the tool. */
                const countryObjList = this.state.DM.countryObjList;

                if (typeof countryObjList !== "undefined" && countryObjList.length === 0) {
                    let DMClone = cloneObj(this.state.DM);
                    DMClone.noPermittedCountries = true;

                    this.setState(
                        {
                            processingServerCall: false,
                            DM: DMClone,
                        },
                        () => {
                            this.createTimer();

                            if (successFn !== "undefined") {
                                successFn();
                            }
                        }
                    );
                } else {
                    let DMClone = cloneObj(this.state.DM);
                    DMClone.noPermittedCountries = false;

                    this.setState(
                        {
                            DM: DMClone,
                        },
                        () => {
                            this.handleGetSNU_ListDM(() => {
                                //this.handleUpdateInputsDM(() => {

                                //this.handleCalculateDM(() => {

                                this.handleGetBaselineVMMC_CoverageDM(() => {
                                    this.handleGetResultsDM(() => {
                                        this.setState({
                                            processingServerCall: false,
                                        });

                                        this.createTimer();

                                        if (successFn !== "undefined") {
                                            successFn();
                                        }
                                    }, errorFn);
                                }, errorFn);

                                //}, errorFn);//handleCalculateDM

                                //}, errorFn);//handleUpdateInputsDM
                            }, errorFn);
                        }
                    );
                }
            }, errorFn);
        }, errorFn);
    };

    handleGetCountryListDM = (successFn, errorFn) => {
        const DM = this.state.DM;

        DMService.getCountryList(
            (response) => {
                /* This will be an object with two 1D arrays in it; mstIDs and names */
                const responseParsed = JSON.parse(response);

                /* If there are no master IDs, assume that the user did not have any country permissions. Assume
               this is because the countries the user did have permissions for did not have data for the newest
               database. If that's the case, tell the user to use another version of the tool to access their
               permitted countries instead because they won't be able to use this version and we can't sign them
               in. */
                if (responseParsed["mstIDs"].length > 0) {
                    let DM_Clone = JSON.parse(JSON.stringify(DM));

                    DM_Clone.countryObjList = [];
                    for (let i = 1; i <= responseParsed["mstIDs"].length; i++) {
                        DM_Clone.countryObjList.push({
                            mstID: responseParsed["mstIDs"][i - 1],
                            name: responseParsed.names[i - 1],
                        });
                    }

                    if (responseParsed["mstIDs"][0] != DM_Clone.selectedCountryMstID) {
                        DM_Clone.targCoverageBySNU.coverages = null;
                        DM_Clone.targCoverageBySNU.names = [];
                    }
                    DM_Clone.selectedCountryMstID = responseParsed["mstIDs"][0];

                    this.setState(
                        {
                            DM: DM_Clone,
                        },
                        successFn
                    );
                } else {
                    let DM_Clone = JSON.parse(JSON.stringify(DM));

                    DM_Clone.countryObjList = [];

                    this.setState(
                        {
                            DM: DM_Clone,
                        },
                        successFn
                    );
                }
            },
            () => {
                this.handleServerError(
                    "An error has occurred while retrieving the country list from the server.",
                    errorFn
                );
            }
        );
    };

    handleGetProvinceListDM = (successFn, errorFn) => {
        const DM = this.state.DM;
        const selectedCountryMstID = DM.selectedCountryMstID;

        DMService.getProvinceList(
            selectedCountryMstID,
            (response) => {
                /* This will be an object with two 1D arrays in it; mstIDs and names */
                const responsedParsed = JSON.parse(response);

                let DM_Clone = JSON.parse(JSON.stringify(DM));
                DM_Clone.province1DStrArray = responsedParsed;
                DM_Clone.selectedProvinceCurrID = 1;

                this.setState(
                    {
                        DM: DM_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error has occurred while retrieving the province list from the server.",
                    errorFn
                );
            }
        );
    };

    handleGetSNU_ListDM = (successFn, errorFn) => {
        const DM = this.state.DM;
        const selectedCountryMstID = DM.selectedCountryMstID;
        const selectedProvinceCurrID = DM.selectedProvinceCurrID;

        DMService.getSNU_List(
            selectedCountryMstID,
            selectedProvinceCurrID,
            (response) => {
                /* This will be an object with two 1D arrays in it; mstIDs and names */
                const responsedParsed = JSON.parse(response);

                let DM_Clone = JSON.parse(JSON.stringify(DM));
                DM_Clone.SNU_1DStrArray = responsedParsed;
                DM_Clone.selectedSNU_CurrID = 1;

                this.setState(
                    {
                        DM: DM_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError("An error has occurred while retrieving the SNU list from the server.", errorFn);
            }
        );
    };

    /*These technically do nothing in a RESTful framework
	handleUpdateInputsDM = (successFn, errorFn) => {

        const DM = this.state.DM;
        const recalculateBool = DM.recalculateBool;
        const selectedCountryMstID = DM.selectedCountryMstID;
        const selectedProvinceCurrID = DM.selectedProvinceCurrID;
        const selectedSNU_CurrID = DM.selectedSNU_CurrID;
        const selectedTargetYear = DM.selectedTargetYear;
        const showGlobalOutputsBool = DM.showGlobalOutputsBool;
        const VMMC_Coverage = DM.VMMC_Coverage;
		const useSNU = DM.targCoverageBySNU.useSNU&&(DM.targCoverageBySNU.coverages!=null);
		
		console.log(useSNU);
		
        if (recalculateBool) {

            DMService.updateInputs(

                selectedCountryMstID,
                selectedProvinceCurrID,
                selectedSNU_CurrID,
                selectedTargetYear,
                (useSNU)?DM.targCoverageBySNU:getVMMC_TargCov1DFltArray(VMMC_Coverage),
                true,
                showGlobalOutputsBool,

                (response) => {

                // let DM_Clone = JSON.parse(JSON.stringify(DM));
                // DM_Clone.??? = response;
                //
                // this.setState({
                //
                //     DM : DM_Clone,
                //
                // }, successFn);

                if (typeof successFn !== "undefined") {

                    successFn();

                }

            }, () => {

                this.handleServerError('An error has occurred while updating inputs on the server.', errorFn);

            });

        }
        else {

            if (typeof successFn !== "undefined") {

                successFn();

            }

        }

    };

    handleCalculateDM = (successFn, errorFn) => {

        const DM = this.state.DM;
        const recalculateBool = DM.recalculateBool;

        if (recalculateBool) {

            DMService.calculate(() => {

                if (typeof successFn !== "undefined") {

                    successFn();

                }

            }, () => {

                this.handleServerError('An error has occurred while running calculations on the server.', errorFn);

            });

        }
        else {

            if (typeof successFn !== "undefined") {

                successFn();

            }

        }

    };*/

    handleGetBaselineVMMC_CoverageDM = (successFn, errorFn) => {
        const DM = this.state.DM;
        const selectedCountryMstID = DM.selectedCountryMstID;
        const selectedProvinceCurrID = DM.selectedProvinceCurrID;
        const selectedSNU_CurrID = DM.selectedSNU_CurrID;
        const selectedFiscalYearStart = DM.selectedFiscalYearStart;
        //const recalculateBool = DM.recalculateBool;

        //if (recalculateBool) {

        DMService.getBaseCoverage(
            selectedCountryMstID,
            selectedProvinceCurrID,
            selectedSNU_CurrID,
            selectedFiscalYearStart,

            (response) => {
                /* This will contain an array of baseline coverages and a baseline coverage year. The array will
                   have two extra elements at the beginning corresponding to the first two rows of the VMMC coverage
                   editor. */
                let responsedParsed = JSON.parse(response);
                /* Server is deleting the age group at index 2 for some reason, so we do the same. */
                responsedParsed.coverage.splice(2, 1);
                responsedParsed.coverage.splice(0, 1);

                let DM_Clone = JSON.parse(JSON.stringify(DM));

                /* Set the coverage array structure up if it's never been set up before. */
                if (DM_Clone.VMMC_Coverage.length === 0) {
                    DM_Clone.VMMC_Coverage = [];

                    for (let a = 1; a <= DMConst.numVMMC_AgeGroups; a++) {
                        DM_Clone.VMMC_Coverage.push([]);

                        for (let i = DMConst.baseCoverage; i <= DMConst.targetCoverage; i++) {
                            if (
                                a >= DMConst.age15t19CurrID &&
                                a <= DMConst.age25t29CurrID &&
                                i === DMConst.targetCoverage
                            ) {
                                DM_Clone.VMMC_Coverage[a - 1].push(DMConst.coverageTarget);
                            } else {
                                DM_Clone.VMMC_Coverage[a - 1].push(0.0);
                            }
                        }
                    }
                }

                for (let a = 1; a <= DMConst.numVMMC_AgeGroups; a++) {
                    DM_Clone.VMMC_Coverage[a - 1][DMConst.baseCoverage - 1] = responsedParsed.coverage[a - 1] * 100;
                }

                DM_Clone.VMMC_BaseCoverageYear = responsedParsed.baseYear;

                this.setState(
                    {
                        DM: DM_Clone,
                    },
                    successFn
                );
            },
            () => {
                this.handleServerError(
                    "An error has occurred while retrieving baseline male circumcision coverage from the server.",
                    errorFn
                );
            }
        );

        /*}//if (recalculateBool) {
        else {

            if (typeof successFn !== "undefined") {

                successFn();

            }

        }*/
    };

    handleGetResultsDM = (successFn, errorFn) => {
        const DM = this.state.DM;
        const selectedCountryMstID = DM.selectedCountryMstID;
        const selectedProvinceCurrID = DM.selectedProvinceCurrID;
        const selectedSNU_CurrID = DM.selectedSNU_CurrID;
        const selectedTargetYear = DM.selectedTargetYear;
        //const recalculateBool = DM.recalculateBool;
        const showGlobalOutputsBool = DM.showGlobalOutputsBool;
        const VMMC_Coverage = DM.VMMC_Coverage;
        const useSNU = DM.targCoverageBySNU.useSNU && DM.targCoverageBySNU.coverages != null;
        const selectedFiscalYearStart = DM.selectedFiscalYearStart;

        //if (recalculateBool) {

        DMService.getResults(
            selectedCountryMstID,
            selectedProvinceCurrID,
            selectedSNU_CurrID,
            selectedTargetYear,
            useSNU ? DM.targCoverageBySNU : getVMMC_TargCov1DFltArray(VMMC_Coverage),
            true,
            showGlobalOutputsBool,
            selectedFiscalYearStart,

            (response) => {
                if (response === "") {
                    this.handleServerError("An error has occurred while retrieving results from the server.", errorFn);
                } else {
                    let DM_Clone = JSON.parse(JSON.stringify(DM));
                    DM_Clone.results = JSON.parse(response);

                    this.setState(
                        {
                            DM: DM_Clone,
                        },
                        successFn
                    );
                }
            },
            () => {
                this.handleServerError("An error has occurred while retrieving results from the server.", errorFn);
            }
        );

        /* }//if (recalculateBool) {
        else {

            if (typeof successFn !== "undefined") {

                successFn();

            }

        }*/
    };

    //==================================================================================================================
    //
    //                                        API Related (passed as props)
    //
    //==================================================================================================================

    handleSignIn = (successFn) => {
        const errorFn = () => {
            this.setState({
                failedToLoad: true,
            });
        };

        this.setState(
            {
                processingServerCall: true,
            },
            () => {
                this.handleSignedIn(() => {
                    this.handleHumanName(() => {
                        this.setState({
                            processingServerCall: false,
                        });

                        this.createTimer();

                        if (successFn !== "undefined") {
                            successFn();
                        }
                    }, errorFn);
                }, errorFn);
            }
        );
    };

    handleLogin = (params, successFn, errorFn) => {
        // This function is passed into the Login component
        let userName = params["username"];
        let password = params["password"];
        LoginService.login(userName, password, window.VIPT_Version, successFn, errorFn);
    };

    handleLogout = () => {
        const state = this.state;
        const selectedModID = state.selectedModID;

        LoginService.logout(
            () => {
                this.setState(
                    {
                        humanName: "",
                        signedIn: false,
                        isGuest: true,
                    },
                    () => {
                        if (selectedModID === GBConst.GB_SC) {
                            this.fetchServerDataSC(() => {
                                this.setState(
                                    {
                                        loading: false,
                                    },
                                    () => {
                                        this.onPageChange(SCConst.SCWelcomeFormPg);
                                    }
                                );
                            });
                        } else if (selectedModID === GBConst.GB_DM) {
                            this.fetchServerDataDM(() => {
                                this.setState(
                                    {
                                        loading: false,
                                    },
                                    () => {
                                        this.onPageChange(DMConst.DMWelcomeFormPg);
                                    }
                                );
                            });
                        }
                    }
                );

                this.destroyTimer();

                this.onPageChange(GBConst.GBLoginFormPg);
            },
            () => {
                this.handleServerError("An error has occurred while logging out.");
            }
        );
    };

    loginSuccess = () => {
        const state = this.state;
        const selectedModID = state.selectedModID;

        LoginService.getHumanName((response) => {
            this.setState({
                humanName: response,
                signedIn: true,
                isGuest: false,
                status: {},
            });

            if (selectedModID === GBConst.GB_SC) {
                this.fetchServerDataSC(() => {
                    this.onPageChange("back");
                });
            } else if (selectedModID === GBConst.GB_DM) {
                this.fetchServerDataDM(() => {
                    this.onPageChange("back");
                });
            } else {
                this.onPageChange(GBConst.GBStartScreenFormPg);
            }
        });
    };

    // handleLogout = () => {
    //
    //      LoginService.logout(() => {
    //
    //          this.setState({
    //              humanName : '',
    //              signedIn  : false,
    //              isGuest   : true,
    //
    //          }, () => {
    //
    //              this.fetchServerDataSC(()=>{
    //
    //                  this.setState({
    //                      pageID  : GBConst.GBStartScreenFormPg,
    //                      loading : false,
    //                  });
    //
    //              });
    //
    //          });
    //
    //          this.destroyTimer();
    //
    //          this.onPageChange(GBConst.GBLoginFormPg);
    //
    //      }, () => {
    //
    //          this.handleServerError('An error has occurred while logging out.');
    //
    //      });
    //  };
    //
    //  loginSuccess = () => {
    //
    //      LoginService.getHumanName((response) => {
    //
    //          this.setState({
    //
    //              humanName : response,
    //              signedIn  : true,
    //              isGuest   : false,
    //              status    : {}
    //
    //          });
    //
    //          this.fetchServerDataSC(() => {
    //
    //              this.onPageChange('back');
    //
    //          });
    //      });
    //
    //  };

    forgotPassword = () => {
        //window.open("https://authentication.avenirhealth.org/?sv=SC&md=fg", "_blank");
        window.open("https://authuser.avenirhealth.org/?sv=SC&md=fg", "_blank");
    };

    createAccount = () => {
        //window.open("https://authentication.avenirhealth.org/?sv=SC&md=new", "_blank");
        window.open("https://authuser.avenirhealth.org/?sv=SC&md=new", "_blank");
    };

    handleManageAccount = () => {
        //window.open("https://authentication.avenirhealth.org/?sv=SC&md=new", "_blank");
        //window.open("https://authuser.avenirhealth.org/?sv=SC&md=new", "_blank");
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderFailedScreen = () => {
        return <div>Failed to load app. Please refresh to see if the issue is resolved.</div>;
    };

    renderDisconnected = () => {
        return <div>Disconnected. Please refresh to start again.</div>;
    };

    renderSplashScreen = () => {
        return <TSplashScreen />;
    };

    renderApp = () => {
        /* State */
        const state = this.state;
        const SC = state.SC;
        const DM = state.DM;

        /* SC */
        const noPermittedCountriesSC = SC.noPermittedCountries;

        /* DM */
        const showHelpDialog = DM.showHelpDialog;
        const noPermittedCountriesDM = DM.noPermittedCountries;

        /* Other */
        const disconnectWarning = state.status.disconnectWarning;
        const drawerContent = state.drawerContent;
        const drawerOpen = state.drawerOpen;
        const drawerTitle = state.drawerTitle;
        const headerVisible = state.headerVisible;
        const humanName = state.humanName;
        const isGuest = state.isGuest;
        const pageID = state.pageID;
        const processingServerCall = state.processingServerCall;
        const selectedModID = state.selectedModID;
        const sideBarOpen = state.sideBarOpen;
        const signedIn = state.signedIn;

        const appBarHeight = 63;
        const appSideBarWidth = 300;
        const navComboBoxHeight = 32;

        let logoImg = null;
        let appBarCaptionStr = getModName(selectedModID);
        /* This will be set below depending on whether SC or DM is showing. If SC is showing and
           the title is clicked, TAppBar will show the SC home page. If DM is showing and the
           title is clicked, TAppBar will show the DM home page.
         */
        let onTitleClick = () => {};
        let appSideBarCustom = null;
        let appSideBar = null;
        let appContentCustom = null;
        let navComboBoxDM = null;
        let showHamburger = false;

        let showSC_Component = false;
        /* SC and DM have different lists of countries. To show SC, make sure that the list of SC countries and
           the user's allowed countries have at least one overlapping country. */
        if (
            SC.allowedCountryMstIDs !== "undefined" &&
            SC.allowedCountryMstIDs.length !== 0 &&
            SC.countryObjList !== "undefined" &&
            SC.countryObjList !== null
        ) {
            let i = 0;
            while (i < SC.allowedCountryMstIDs.length && !showSC_Component) {
                const allowedCountryMstID = SC.allowedCountryMstIDs[i];

                let j = 0;
                while (j < SC.countryObjList.length && !showSC_Component) {
                    const countryObjListMstID = SC.countryObjList[j]["mstID"];

                    if (allowedCountryMstID === countryObjListMstID) {
                        showSC_Component = true;
                    }

                    j++;
                }

                i++;
            }
        }

        const showGB_Component = selectedModID === GBConst.GB_GB;

        showSC_Component = selectedModID === GBConst.GB_SC && showSC_Component && !noPermittedCountriesSC;

        const showDM_Component =
            selectedModID === GBConst.GB_DM &&
            !noPermittedCountriesDM &&
            typeof DM.countryObjList !== "undefined" &&
            DM.countryObjList.length !== 0 &&
            DM.countryObjList[0].mstID !== 0 &&
            DM.countryObjList[0].name !== "" &&
            DM.province1DStrArray.length !== 0 &&
            DM.SNU_1DStrArray.length !== 0 &&
            DM.VMMC_Coverage.length !== 0;

        let redirectForm = null;

        if (
            !processingServerCall &&
            ((selectedModID === GBConst.GB_SC && !showSC_Component) ||
                (selectedModID === GBConst.GB_DM && !showDM_Component))
        ) {
            redirectForm = <GBRedirectForm appBarHeight={appBarHeight} />;
        }

        /* GB, SC, and DM all use the same custom app bar, since they are so similar. The custom app
           content will vary by module, as will the custom app side bar. Note that GB does not have
           or need a custom app side bar though. */
        const appBarCustom = (
            <GBAppBarCustom
                handleManageAccount={this.handleManageAccount}
                handleSignOut={this.handleLogout}
                onHelpClick={this.onHelpClickDM}
                humanName={humanName}
                isGuest={isGuest}
                onModuleChange={this.onModuleChange}
                onPageChange={this.onPageChange}
                selectedModID={selectedModID}
                signedIn={signedIn}
            />
        );

        if (showGB_Component) {
            appContentCustom = (
                <GBAppContentCustom
                    handleLogin={this.handleLogin}
                    loginSuccess={this.loginSuccess}
                    forgotPassword={this.forgotPassword}
                    createAccount={this.createAccount}
                    pageID={pageID}
                    onPageChange={this.onPageChange}
                    onModuleChange={this.onModuleChange}
                />
            );

            onTitleClick = () => {
                this.onPageChange(GBConst.GBStartScreenFormPg);
            };
        } else if (showSC_Component) {
            if (window.VIPT_Version === window.VIPT_Versions.eSwatini) {
                appBarCaptionStr += " (eSwatini)";
                logoImg = (
                    <img
                        style={{
                            verticalAlign: "middle",
                            marginRight: "10px",
                            width: "50px",
                            border: "1px solid black",
                        }}
                        src={eSwatiniFlagIcon}
                        alt="" // to avoid hint
                    />
                );
            } else {
                logoImg = (
                    <img
                        alt="" // to avoid hint
                        key={"modIconDivImg"}
                        src={SC_Icon}
                    />
                );
            }

            onTitleClick = () => {
                this.onPageChange(SCConst.SCWelcomeFormPg);
            };

            if (!processingServerCall) {
                appContentCustom = (
                    <SCAppContentCustom
                        handleLogin={this.handleLogin}
                        loginSuccess={this.loginSuccess}
                        forgotPassword={this.forgotPassword}
                        createAccount={this.createAccount}
                        processingServerCall={processingServerCall}
                        pageID={pageID}
                        onPageChange={this.onPageChange}
                        onDrawerChange={this.onDrawerChangeSC}
                        config={SC.config}
                        configExtra={SC.configExtra}
                        onConfigChange={this.onConfigChangeSC}
                        displayOL={SC.displayOL}
                        mstIDsObj={SC.mstIDsObj}
                        indInfo={SC.indInfo}
                        packChart={SC.packChart}
                        packTable={SC.packTable}
                    />
                );
            }
        } else if (showDM_Component) {
            if (window.VIPT_Version === window.VIPT_Versions.eSwatini) {
                appBarCaptionStr += " (eSwatini)";
                logoImg = (
                    <img
                        style={{
                            verticalAlign: "middle",
                            marginRight: "10px",
                            width: "50px",
                            border: "1px solid black",
                        }}
                        src={eSwatiniFlagIcon}
                        alt="" // to avoid hint
                    />
                );
            } else {
                logoImg = (
                    <img
                        alt="" // to avoid hint
                        key={"modIconDivImg"}
                        src={DM_Icon}
                    />
                );
            }

            /* Everything showing up in app content for DM should have the navigation dropdown except
               the login screen. */
            if (pageID !== GBConst.GBLoginFormPg) {
                navComboBoxDM = (
                    <DMNavComboBox
                        height={navComboBoxHeight}
                        navOption={DM.navOptionByte}
                        onNavOptionChange={this.onNavOptionChangeDM}
                        selectedCountryMstID={DM.selectedCountryMstID}
                        showGlobalOutputsBool={DM.showGlobalOutputsBool}
                        showTargBySNU={DM.targCoverageBySNU.useSNU}
                    />
                );
            }

            if (!processingServerCall) {
                appContentCustom = (
                    <DMAppContentCustom
                        handleLogin={this.handleLogin}
                        loginSuccess={this.loginSuccess}
                        forgotPassword={this.forgotPassword}
                        createAccount={this.createAccount}
                        navComboBoxHeight={navComboBoxHeight}
                        processingServerCall={processingServerCall}
                        pageID={pageID}
                        onPageChange={this.onPageChange}
                        DM={DM}
                        handleTargBySNU={this.onHandleTargBySNUCovChange}
                        covTable={this.state.covTable}
                        setCovTable={this.setCovTable}
                        createTable={this.createTable}
                    />
                );
            }

            onTitleClick = () => {
                this.onPageChange(DMConst.DMWelcomeFormPg, () => {
                    this.onNavOptionChangeDM(DMConst.introOp);
                });
            };
        }

        if (showSC_Component) {
            appSideBarCustom = (
                <SCAppSideBarCustom
                    isGuest={isGuest}
                    allowedCountryMstIDs={SC.allowedCountryMstIDs}
                    countryObjList={SC.countryObjList}
                    selectedCountryCode={SC.selectedCountryCode}
                    pageID={pageID}
                    onPageChange={this.onPageChange}
                    onDrawerChange={this.onDrawerChangeSC}
                    onCountryChange={this.onCountryChangeSC}
                />
            );
        } else if (showDM_Component) {
            appSideBarCustom = (
                <DMAppSideBarCustom
                    countryObjList={DM.countryObjList}
                    province1DStrArray={DM.province1DStrArray}
                    //recalculateBool           = {DM.recalculateBool}
                    onRecalculateChange={this.onRecalculateChangeDM}
                    selectedCountryMstID={DM.selectedCountryMstID}
                    onCountryChange={this.onCountryChangeDM}
                    selectedFiscalYearStart={DM.selectedFiscalYearStart}
                    onFiscalYearStartChange={this.onFiscalYearStartChangeDM}
                    selectedProvinceCurrID={DM.selectedProvinceCurrID}
                    onProvinceChange={this.onProvinceChangeDM}
                    selectedSNU_CurrID={DM.selectedSNU_CurrID}
                    onSNU_Change={this.onSNU_ChangeDM}
                    selectedTargetYear={DM.selectedTargetYear.toString()}
                    onTargetYearChange={this.onTargetYearChangeDM}
                    showGlobalOutputsBool={DM.showGlobalOutputsBool}
                    onShowGlobalOutputsChange={this.onShowGlobalOutputsChangeDM}
                    SNU_1DStrArray={DM.SNU_1DStrArray}
                    VMMC_Coverage={DM.VMMC_Coverage}
                    onVMMC_CoverageChange={this.onVMMC_CoverageChange}
                    VMMC_BaseCoverageYear={DM.VMMC_BaseCoverageYear}
                    // allowedCountryMstIDs = {allowedCountryMstIDs}
                    onDrawerChange={this.onDrawerChangeSC}
                    isGuest={isGuest}
                    pageID={pageID}
                    onPageChange={this.onPageChange}
                    DM={DM}
                    handleTargBySNU={this.onHandleTargBySNUFlagChange}
                    width={appSideBarWidth}
                />
            );
        }

        if (showSC_Component || showDM_Component) {
            appSideBar = (
                <TErrorBoundary>
                    <TAppSideBar
                        open={sideBarOpen}
                        width={appSideBarWidth}
                    >
                        {appSideBarCustom}
                    </TAppSideBar>
                </TErrorBoundary>
            );

            showHamburger = true;
        }

        const appBar = (
            <TErrorBoundary>
                <TAppBar
                    logo={logoImg}
                    caption={appBarCaptionStr}
                    height={appBarHeight}
                    showHamburger={showHamburger}
                    onHamburgerClick={() =>
                        this.setState({
                            sideBarOpen: selectedModID !== GBConst.GB_GB && !sideBarOpen,
                        })
                    }
                    onTitleClick={onTitleClick}
                    style={{
                        ...Theme.vCenteredStyle,
                        fontFamily: Theme.fontFamily,
                    }}
                >
                    {appBarCustom}
                </TAppBar>
            </TErrorBoundary>
        );

        const appContent = (
            <TErrorBoundary>
                <TAppContent
                    appSideBarWidth={appSideBarWidth}
                    sideBarVisible={sideBarOpen}
                    pageID={pageID}
                >
                    {navComboBoxDM}
                    {appContentCustom}
                </TAppContent>
            </TErrorBoundary>
        );

        /* Guessing that the drawer heading is created in SCDataEntryDrawer instead of
           being displayed here like the other drawers because of the onSubmitBtnClick. There is
           lots of data-entry-specific stuff happening there that we don't have access
           to in App.js. The DrawerHeader is hidden in App.js by passing headerVisible =
           false into TDrawerForm for the SCDataEntryDrawer. Then it's created in SCDataEntryDrawer
           instead. */
        const drawerForm = (
            <TDrawerForm
                open={drawerOpen}
                title={drawerTitle}
                onClose={this.onDrawerChangeSC}
                headerVisible={headerVisible}
            >
                {drawerContent}
            </TDrawerForm>
        );

        const commWithServerDialog = (
            <TDialog
                caption={"Communicating with server..."}
                icon={
                    <TWifiAnimation
                        style={{
                            marginRight: "20px",
                            float: "left",
                        }}
                    />
                }
                visible={processingServerCall}
                style={{
                    width: "370px",
                }}
            />
        );

        const disconnectDialog = (
            <TDialog
                caption="Disconnecting warning"
                message="You may be disconnected soon due to inactivity.  Would you like to remain signedIn?"
                actions={["mrYes", "mrNo"]}
                onClose={this.handleDisconnectWarningDialogClose}
                visible={disconnectWarning}
                style={{
                    width: "370px",
                }}
            />
        );

        const helpDialog = (
            <TDialog
                caption=""
                content={
                    <img
                        src={OnlineHelpIcon}
                        alt="" // to avoid hint
                    />
                }
                actions={["mrOK"]}
                onClose={this.onHelpClickDM}
                outerStyle={{
                    height: 1000,
                    width: 1500,
                }}
                maxWidth={"xl"}
                visible={showHelpDialog}
            />
        );

        return (
            <div>
                {appBar}
                {appSideBar}
                {appContent}
                {redirectForm}
                {drawerForm}
                {commWithServerDialog}
                {disconnectDialog}
                {helpDialog}
            </div>
        );
    };

    render() {
        /* State */
        const state = this.state;
        const failedToLoad = state.failedToLoad;
        const loading = state.loading;
        const signedIn = state.signedIn;
        const status = state.status;
        const sessionExists = status.sessionExists;

        if (status.hasOwnProperty("sessionExists")) {
            if (!sessionExists && signedIn) {
                return this.renderDisconnected();
            }
        }

        return (
            <div>
                {failedToLoad ? this.renderFailedScreen() : loading ? this.renderSplashScreen() : this.renderApp()}
            </div>
        );
    }
}

export default App;
